import type { ReactNode } from 'react'
import { AevocamTooltip } from './AevocamTooltip'

type Option = {
  value: string
  label: string
}

type Props = {
  tooltip: ReactNode
  value: string | number
  onChange: (value: string) => void
  options: Option[]
}

export function AevocamActionSelect({
  tooltip,
  value,
  onChange,
  options,
}: Props) {
  return (
    <AevocamTooltip label={tooltip}>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
    </AevocamTooltip>
  )
}
